import { ChangeDetectorRef, Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BatchEntryService } from 'src/service/batch-entry.service';
import { ConfigurationManagementService } from 'src/service/configuration-management.service';
import { LanguageManagementService } from 'src/service/language-management.service';
import { ActiveInactiveFor, FocusInputType, InteractionType, KeyValues15, KeyValues5, LocalService, NumericConfig, BatchEntryDetailsInitialization, Status, UpadateBatchEntryDetailFor, Wrappers15 } from 'src/service/local.service';

@Component({
  selector: 'app-batch-entry-details',
  templateUrl: './batch-entry-details.component.html',
  styleUrl: './batch-entry-details.component.scss'
})
export class BatchEntryDetailsComponent {
  lstSectionConfigKeys: string[] = ["common", "table", "purchase_entry"];
  ctryCode: string = ''; businessId: string = ''; interactionType = 0; maxBodyHeight = 0;
  purchaseEntryId: string = ''; isShowInActive: boolean = false;
  batchEntryDetails: BatchEntryDetailsInitialization; isShowSpinnerCount = 0;
  source: Wrappers15; data: KeyValues15; searchItems: KeyValues5[] = [];
  numericConfig: NumericConfig = { isDecimalAllowed: true } as NumericConfig;
  isUpdateInProgress = false;

  isNoValidity: boolean = false; isAutoDeactive: boolean = true;

  pageNameId = '_purchase_entry_detail_';
  elementIds: any = {
    qty: 'txt' + this.pageNameId + 'qty',
    price: 'txt' + this.pageNameId + 'price',
    add: 'btn' + this.pageNameId + 'add',
    product_dd: 'dd' + this.pageNameId + 'product'
  };

  constructor(public localService: LocalService, private route: ActivatedRoute, private configurationManagementService: ConfigurationManagementService, private cdr: ChangeDetectorRef, private languageManagementService: LanguageManagementService, private batchEntryService: BatchEntryService) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.route.params.subscribe(routeParams => {
      this.interactionType = routeParams.interactionType;
      this.businessId = routeParams.businessId;
      this.purchaseEntryId = routeParams.id;
      //this.configurationManagementService.ensurePageActions(PageKey.BatchEntryDetails, this.businessId);
      if (this.interactionType != InteractionType.User && (this.businessId == '' || this.businessId == '0')) {
        this.localService.redirectToSeller();
      } else {
        this.localService.saveUrl();
        this.localService.setBasicParams(routeParams.ctryCode, routeParams.userId, routeParams.interactionType, routeParams.businessId);
        this.ctryCode = routeParams.ctryCode;
        this.onInitiate();
      }
    });
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetCustomBodyHeight();
    this.cdr.detectChanges();
  }

  onInitiate() {
    this.batchEntryService.getBatchEntryDetailsInitialization(this.businessId, this.purchaseEntryId).subscribe(result => {
      this.batchEntryDetails = result;
      this.isNoValidity = this.batchEntryDetails.batchEntry.v5 == '1';
      this.isAutoDeactive = this.batchEntryDetails.batchEntry.v6 == '1';
      this.source = this.batchEntryDetails.source;
      this.onResetItem();
    });
  }

  onLoad() {
    this.batchEntryService.getBatchEntryDetails(this.businessId, this.purchaseEntryId, this.source && this.source.paging ? this.source.paging : undefined, !this.isShowInActive).subscribe(result => {
      this.source = result;
    });
  }

  onAction(index: number, key: string) {
    switch (index) {
      case 1: {
        const item = this.source.items.find(x => x.key == key);
        if (item) {
          const newValue = item.v2 ? parseFloat(item.v2) : 0;
          const oldValue = item.v11 ? parseFloat(item.v11) : 0;
          if (newValue != oldValue) {
            this.onUpdateItem(item.key, item.v2, UpadateBatchEntryDetailFor.Quantity);
          }
        }
      } break;
    }
  }

  onSaveBatchEntryDetail() {
    this.data.v3 = this.batchEntryDetails.batchEntry.v3;
    this.data.v5 = this.isNoValidity ? '1' : '0';
    this.data.v6 = this.isAutoDeactive ? '1' : '0';
    this.isAutoDeactive = this.batchEntryDetails.batchEntry.v6 == '1';
    this.batchEntryService.saveBatchEntryDetail(this.purchaseEntryId, this.businessId, this.data).subscribe(result => {
      this.localService.showInformationByStatus(result.statusWithId.status);
      if (result.statusWithId.status == Status.Success) {
        this.onUpdateLocalItem(result.content);
        this.onResetItem();
      }
    });
  }

  onUpdateLocalItem(content: KeyValues15, isBringTop = true) {
    if (isBringTop) {
      this.source.items = this.source.items.filter(x => x.key != content.key);
      this.source.items.unshift(content);
      this.source.paging.totalCount = this.source.paging.totalCount + 1;
    } else {
      let item = this.source.items.find(x => x.key == content.key);
      if (item) {
        item.v1 = content.v1;
        item.v2 = content.v2;
        item.v3 = content.v3;
        item.v4 = content.v4;
        item.v5 = content.v5;
        item.v6 = content.v6;
        item.v7 = content.v7;
        item.v8 = content.v8;
        item.v9 = content.v9;
        item.v10 = content.v10;
        item.v11 = content.v11;
        item.v12 = content.v12;
        item.v13 = content.v13;
        item.v14 = content.v14;
        item.v15 = content.v15;
      }
    }
  }

  onUpdateItem(purchaseEntryDetailId: string, strValue: string, actionFor: UpadateBatchEntryDetailFor) {
    if (!this.isUpdateInProgress) {
      this.isUpdateInProgress = true;
      this.batchEntryService.updateBatchEntryDetail(purchaseEntryDetailId, actionFor, strValue).subscribe(result => {
        this.localService.showInformationByStatus(result.statusWithId.status);
        if (result.statusWithId.status == Status.Success) {
          this.onUpdateLocalItem(result.content, false);
        }
        this.isUpdateInProgress = false;
      });
    }
  }

  onResetItem(isFocus = true) {
    this.searchItems = [];
    this.data = {
      v1: '', //Product id
      v2: '', //Quantity
      v13: '' //Batch Number
    } as KeyValues15;

    if (isFocus) {
      this.localService.onFocusNextInput(this.elementIds.product_dd, FocusInputType.NgxDropDown);
    }
  }

  onRemoveProduct() {
    this.onResetItem();
  }

  onFocusProducts() {
    if (this.searchItems.length == 0) {
      this.onSearch();
    }
  }

  onSearch(strSearchKey: string = '') {
    if (strSearchKey && strSearchKey.trim().length > 2) {
      this.isShowSpinnerCount++;
      this.batchEntryService.getSearchedProducts(this.businessId, strSearchKey).subscribe(result => {
        this.isShowSpinnerCount--;
        this.searchItems = result;
      });

      if (this.searchItems.length == 1 && this.searchItems[0].v4 == '1') {
        this.data.v1 = this.searchItems[0].key;
        this.localService.onFocusNextInput(this.elementIds.qty, FocusInputType.TextBox);
      }
    } else {
      this.searchItems = [];
    }
  }

  onQrScanned(value) {
    this.onSearch(value);
  }

  onActiveInactiveStatus(key: string) {
    this.batchEntryService.activeInactiveStatus(key, ActiveInactiveFor.BatchEntryDetail).subscribe(result => {
      this.localService.showInformationByStatus(result.status);
      if (result.status == Status.Success) {
        let item = this.source.items.find(x => x.key == key);
        if (item) {
          item.v4 = item.v4 == '1' ? '0' : '1';
        }
      }
    });
  }
}
